import React, { useState } from 'react';
import './hover.css'

function ImageWithHoverText(props) {
  const [hovered, setHovered] = useState(false);

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  return (
    <div
      className="image-container"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{cursor: 'pointer'}}
    >
      <img src={props.src} alt={props.alt} className="image buzz-out-on-hover" />
      {hovered && <span className="image-name">{props.name}</span>}
    </div>
  );
}

export default ImageWithHoverText;
